<template>
	<div class="product">
		<NavBer></NavBer>
		<div>
			<el-carousel height="500px" :autoplay="true" arrow="never" :interval="3000">
				<el-carousel-item v-for="(item, index) in Rotation" :key="index">
					<div class="rotationimg">
						<img :src="item.url" alt="" />
					</div>
				</el-carousel-item>
			</el-carousel>
		</div>

		<div class="w content">
			<el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/01.png" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">七叶洋地黄双苷滴眼液</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字HJ20130295</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>0.4ml*10支</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>Pharma Stulln GmbH</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>老年性黄斑病变；黄斑区相关病变（中心性浆液性脉络膜视网膜病变、糖尿病视网膜病变、高血压视网膜病变、视神经萎缩、动脉硬化性视网膜病变等）；所有类型的眼疲劳，包括肌肉性的，适应性的或神经性的。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/02.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">乳果糖口服溶液</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字H20223553</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>100ml/瓶/盒</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>四川德峰药业有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于治疗高血氨症及由血氨升高引起的疾病;用于治疗慢性功能性便秘。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/03.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">苦参凝胶</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字H20223553</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>5g*5支</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>贵阳新天药业股份有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于宫颈糜烂、赤白带下（白带中夹杂着血丝）、滴虫性阴道炎、阴道霉菌感染等妇科慢性炎症。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/04.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">甲磺酸倍他司汀片（敏使朗）</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字H20040130</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>5g*5支</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>卫材（中国）药业有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>主要功效下列疾病伴发的眩晕、头晕感。梅尼埃病、梅尼埃综合征、眩晕症。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/05.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">盐酸二甲双胍片</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字H20023370</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>0.5g*20p</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>中美上海施贵宝制药有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于单纯饮食控制及体育锻炼治疗无效的2 型糖尿病，特别是肥胖的2型糖尿病。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/06.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">六神丸</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字Z20020069</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>10粒*6支</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>上海雷允上药业有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于烂喉丹痧，咽喉肿痛，喉风喉痈，单双乳蛾，小儿热疖，痈疡疔疮，乳痈发背，无名肿毒。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/07.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">摩罗丹</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字Z13021325</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>9g*9丸</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>邯郸制药股份有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于慢性萎缩性胃炎及胃疼,胀满,痞闷,纳呆,嗳气,烧心等症。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
      <el-row>
				<el-col :span="8">
					<div class="grid-content">
						<img src="../assets/images/product/08.jpg" alt="" />
					</div>
				</el-col>
				<el-col :span="16">
					<div class="grid-content bgs">
						<h4 class="commodity">复方利血平氨苯蝶啶片</h4>
						<hr />
						<div><span>【批准文号】</span> <span>国药准字H11022335</span></div>
						<div>
							<span>【规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格】</span>
							<span>30片</span>
						</div>
						<div>
							<span>【产&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;地】</span>
							<span>华润双鹤药业股份有限公司</span>
						</div>
						<div>
							<span>【主治功能】</span>
							<span
								>用于治疗轻、中度高血压.对重度高血压需与其它降压药合用。 主要功效用于治疗轻、中度高血压.对重度高血压需与其它降压药合用。</span
							>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<Footbar></Footbar>
	</div>
</template>

<script>
import NavBer from "../components/nav";
import Footbar from "../components/footbar";
export default {
	name: "product",
	data() {
		return {
			Rotation: [
				{
					url: require("../assets/images/product/01.png"),
				},
				{
					url: require("../assets/images/product/02.jpg"),
				},
				{
					url: require("../assets/images/product/03.jpg"),
				},
				{
					url: require("../assets/images/product/04.jpg"),
				},
				{
					url: require("../assets/images/product/05.jpg"),
				},
				{
					url: require("../assets/images/product/06.jpg"),
				},
				{
					url: require("../assets/images/product/07.jpg"),
				},
				{
					url: require("../assets/images/product/08.jpg"),
				},
			],
		};
	},
	components: {
		NavBer,
		Footbar,
	},
};
</script>

<style scoped>
.product {
	padding-top: 90px;
}
.el-carousel__item h3 {
	height: 500px;
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 500px;
	margin: 0;
}

.rotationimg {
	/* width: 600px; */
	/* height: 300px; */
	text-align: center;
	/* margin: 0 auto; */
	margin-top: 100px;
}
.rotationimg img {
	width: 500px;
	height: 400px;
	/* margin: o auto; */
}

.bg1 {
	width: 100%;
	height: 500px;
	margin-bottom: 10px;
}

.bg1 img {
	width: 100%;
	height: 100%;
}

.content {
	margin-top: 60px;
}

.commodity {
	margin: 20px 0 10px 0;
}

.bgs {
	/* background-color: pink; */
	padding-left: 100px;
	padding-right: 100px;
}

.el-row {
	margin-bottom: 60px;
}

.el-col {
	border-radius: 4px;
}

.bg-purple-dark {
	background: #99a9bf;
}

.grid-content {
	border-radius: 4px;
	height: 260px;
	/* border: solid 1px #333; */
}

.grid-content img {
	/* width: 100%; */
	height: 100%;
}
</style>
